import { TokenInjectionType } from "./token-injection-type.enum";
import { TokenValueFormatter } from "./token-value-formatter.interface";


export class TokenValue<T> {
  constructor(public key: string, public value: T, public formatter: TokenValueFormatter = null, public injectionType = TokenInjectionType.ignore) {}
}
